export default {
    init() {
        this.initInviteRoleSelect();
        this.initUserRoleSelect();
        // this.usersListActionsToggle();
    },


    initInviteRoleSelect() {
        let select = $('.user-role-select select');
        if (select.length > 0) {
            select.select2({ dropdownAutoWidth: true,  width: '100%', dropdownCssClass: "radio-dropdown"});
        }
    },

    initUserRoleSelect() {
        let selectRole = $('.invite-role-select select');
        if (selectRole.length > 0) {
            selectRole.select2({dropdownCssClass: "radio-dropdown"});
        }

        let selectPermission = $('.invite-permission-select select');
        if (selectPermission.length > 0) {
            selectPermission.select2({ dropdownAutoWidth: true, width: 'resolve', dropdownCssClass: "radio-dropdown"});
        }
    },

}